import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import Form from "../../../form/Form";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import { taxonomyAddEdit, taxonomyDetails, taxonomyList } from "../../../../services/taxonomyService";
import Button from "../../../form/Button";
import Select from "../../../form/select/Select";
import FlexibleSelect from "../../../form/select/FlexibleSelect";

const TagManage = ({ open, close = () => {}, getResponse = () => {}, data = {}, type }) => {
  const validation = {
    title: { required: true, message: "Name is required" },
    // status: { required: true, message: "Status is required" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });
  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["tag-details", data?._id],
    queryFn: async () => {
      const res = await taxonomyDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        title: details?.title,
        content: details?.content,
        status: details?.status,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await taxonomyAddEdit({
        ...val,
        type: type,
        ...(data?._id && { id: data._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      if (res?.status === 200 || res?.status === 201) {
        resetField();
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="relative px-3 py-3">
      <Form onSubmit={onSubmit} handleSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-3">
          <Input
            label={"Title"}
            inputType={"title"}
            inputPlaceholder="Enter title"
            inputName={"title"}
            value={values?.title}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="grid grid-cols-1 gap-3">
          <Textarea
            label={"Content"}
            inputPlaceholder={"Enter content"}
            inputName={`content`}
            inputValue={values?.content || ""}
            onChange={(e) =>
              handleChange({
                target: { name: "content", value: e.target.value },
              })
            }
          />
        </div>
        <div className="grid grid-cols-1 gap-3">
          <FlexibleSelect
            label={"Status"}
            placeholder={"Choose status"}
            onChange={(e) => handleChange({ target: { name: "status", value: e } })}
            selectedValue={values?.status}
            dropdownData={[
              { name: "Active", value: "active" },
              { name: "Inactive", value: "inactive" },
            ]}
            {...formValidate(errors, "status")}
          />
        </div>
        <div className="pt-3 pb-6 flex justify-end">
          <Button
            buttonType="submit"
            buttonClasses={"min-w-36"}
            buttonLabel={details?._id ? "Update" : "Save"}
            {...((isLoading || detailsLoading) && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </Form>
    </div>
  );
};

export default TagManage;
